var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5557_42387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.363281,
    width: 50,
    height: 37,
    rx: 5,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 25.0303H50.6758V37.3636H0.675781V25.0303Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 0.363281H50.6758V12.6966H0.675781V0.363281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1516 7.76367H11.3897C10.0748 7.76367 9.00879 8.86804 9.00879 10.2303V16.397C9.00879 17.7593 10.0748 18.8637 11.3897 18.8637H16.1516C17.4666 18.8637 18.5326 17.7593 18.5326 16.397V10.2303C18.5326 8.86804 17.4666 7.76367 16.1516 7.76367Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9611 7.76367H12.5802C11.2652 7.76367 10.1992 8.86804 10.1992 10.2303V15.1637C10.1992 16.526 11.2652 17.6303 12.5802 17.6303H14.9611C16.2761 17.6303 17.3421 16.526 17.3421 15.1637V10.2303C17.3421 8.86804 16.2761 7.76367 14.9611 7.76367Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1992 15.163L13.7706 13.9297L17.3421 15.163L14.9611 17.6297H12.5802L10.1992 15.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5801 10.2295H14.961V12.6962H12.5801V10.2295Z",
    fill: "#FFDA2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5557_42387"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.363281,
    width: 50,
    height: 37,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/Slovakia.7b1ff5208f53c9b16b4ee35b656fafca.svg";
export { ForwardRef as ReactComponent };